// export const imageContainerStyle = 
// { display: 'inline-block', imgWidth: 333 }
import {coreColors} from '../../../styles/shared/variables';

export const imgBorderStyle = {border: '1px solid #ddd',
    borderRadius: '4px',
    borderWidth: '5px',
    borderColor:  coreColors.blue300,
    borderStyle: 'outset'}

export const desktopWelcomeTextContainerStyle= {
    display: 'inline-block',
    width: '50%',
    verticalAlign: 'top',
    marginLeft: '50px'

}

export const tabletProjectAndAboutTabletTextStyle = {
    marginTop: '-30px',
    marginLeft: '5%',
    marginBottom: '40px',
    width: '80%'
}

export const welcomeHeaderStyle = {
    fontSize: '36px'
}


// WEBPACK FOOTER //
// ./src/components/summary/styles/desktop.js